import * as React from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useNavigate } from 'react-router';
import { LD_ANONYMOUS_CONTEXT } from '@studio/constants/api-constants';
import { SESSION_STRINGS } from '@studio/constants/software-encoder';
import { TrackEventName } from '@studio/constants/tracking-constants';
import UrlPaths from '@studio/constants/url-paths';
import { useTrackSegment } from '@studio/hooks/use-track-segment';
import { performLogout } from '@studio/storeV2/authentication/helpers/perform-logout';

const useSignOut = (): (() => void) => {
  const ldClient = useLDClient();
  const navigate = useNavigate();
  const track = useTrackSegment();

  return React.useCallback(() => {
    track({ eventName: TrackEventName.USER_LOGOUT });
    window.analytics.reset();
    ldClient?.identify(LD_ANONYMOUS_CONTEXT).catch((error) => {
      console.error('error initializing Launch Darkly:', error.message);
    });
    const resiSoftwareUrl = sessionStorage.getItem(SESSION_STRINGS.HREF);
    void performLogout({
      onSuccess: resiSoftwareUrl
        ? () => {
            window.location.href = resiSoftwareUrl;
          }
        : () => navigate(UrlPaths.ROOT, { replace: true }),
    });
  }, [ldClient, navigate, track]);
};

export default useSignOut;
